'use strict';

function UserPayees({ client, fspId, payeeId }) {

  return {
    returnModel: {
      name: 'userPayee',
    },
    baseUrl: `/fsps/${fspId}/payees/${payeeId}/userpayees`,

    create: function create(data, queryParams, cb) {
      return client.executeRequest('POST', this.baseUrl, {
        data,
        queryParams,
        cb,
        returnModel: this.returnModel,
      });
    },
  };

}

module.exports = UserPayees;
